import type { FiltrosInlineProps } from "./types-filtros-inline";
import { useFiltrosInline } from "./use-filtros-inline";
import { FiltrosInlineView } from "./view-filtros-inline";

/**
 * Exceção ao FilterPanel só do Painel: ADR 0013 (`docs/adr/0013-painel-controle-filtros-inline.md`).
 * Filtros do Painel desenhados no topo da tabela (Figma 4434:52897), sem botão "Filtros" nem painel: cada campo aplica ao
 * mudar. Entra no `quickFilters` da `ListaToolbar`, que já põe os campos à esquerda e as ações e o ⋮ à direita.
 */
export function FiltrosInline(props: FiltrosInlineProps) {
  const vm = useFiltrosInline(props);

  return <FiltrosInlineView {...vm} />;
}

export type * from "./types-filtros-inline";
